<template>
  <v-container fluid grid-list-xl page>
    <!-- Your contet -->
    <v-parallax src="/static/full-bg-9.jpg">
      <v-layout align-center column justify-center>
        <div class="display-4 white--text bold mb-5">Securyty</div>
        <div class="display-1 blue--text darken-4 bold">
          Comienza a usar SECURYTY para automatizar procesos, acelerar el cierre
          de contratos <br />
          y maximizar el ROI del proceso de digitalización.
        </div>
      </v-layout>
    </v-parallax>
    <spacer></spacer>
    <div class="display-2 black--text text--darken-1 mt-4">
      Firma electrónica, identificación de personas y análisis de documentos
    </div>
    <div class="title grey--text text--darken-2 mt-2">
      Securyty proporciona un conjunto de servicios de confianza para mejorar la
      seguridad legal de tus comunicaciones y transacciiones digitales.
    </div>

    <v-layout class="mt-4">
      <v-flex>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6 lg6>
                <v-card flat tile>
                  <v-img
                    src="/static/electronicsignature.png"
                    max-height="225"
                    contain
                    aspect-ratio="0.75"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Firma Electrónica</h3>
                      <div>
                        Ampliamente aceptada en un gran número de procesos de
                        negocio, consiste en un marcador electróniico que indica
                        que una persona está aprobando un contrato o los
                        contenidos de un documento.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goSignature()"
                      >Ver más</v-btn
                    >
                    <v-btn
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goLegal()"
                      >Información Legal</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg6>
                <v-card flat tile>
                  <v-img
                    src="/static/certemail.svg"
                    max-height="225"
                    contain
                    aspect-ratio="0.75"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Notificación Certificada</h3>
                      <div>
                        Comunicaciones electrónica garantizadas con trazabilidad
                        de la entrega y lectura y certificación del contenido.

                        <br />Este tipo de envío permite reducir los costes
                        asociados a envios de comunicaciones físicas manteniendo
                        la validez de las mismas en cuanto a certificación del
                        acto de comunicación.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goNotification()"
                      >Ver Más</v-btn
                    >
                    <!--  <v-btn flat color="orange" to="/blank-page" >Legal</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------------- -->

              <v-flex xs12 md6 lg6>
                <v-card flat tile>
                  <v-img
                    src="/static/videoonboarding.png"
                    max-height="225"
                    contain
                    aspect-ratio="0.75"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Video Identificación</h3>
                      <div>
                        Verifica la identidad de tus clientes o empleados de
                        forma remota y desatendida, simplificando los trámites
                        para los clientes y cumpliendo normativas existentes.

                        <br />Comprueba coincidencia de caras con fotos en
                        documentos y validez de los mismos
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goIdentification()"
                      >Ver Más</v-btn
                    >
                    <!--  <v-btn flat color="orange" to="/blank-page" >Legal</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg6>
                <v-card flat tile>
                  <v-img
                    src="/static/docscan.png"
                    max-height="225"
                    contain
                    aspect-ratio="0.75"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">
                        Verificación y OCR de documentos
                      </h3>
                      <div>
                        Encuentra documentos de identidad en una imagen,
                        verifica su validez y automatiza la extracción de datos
                        de los mismos utilizando una de las mejores OCR del
                        mercado para facilitar el proceso de aportación de
                        información por parte de tus clientes y mejorando la
                        calidad de los datos recogidos.

                        <br />Especialmente útil en procesos KYC
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      flat
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goOcr()"
                      >Ver Más</v-btn
                    >
                    <!--  <v-btn flat color="orange" to="/blank-page" >Legal</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-card flat tile>
                  <v-img
                    src="/static/SecurytySigner.png"
                    max-height="225"
                    contain
                    aspect-ratio="0.75"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">
                        Aplicación cliente de Securyty
                      </h3>
                      <div>
                        Con nuestra aplicación web cliente podrás crer
                        fácilemente nuevos envios de documentos para firmar y
                        seguir el estado de todas tus operaciones. Podrás
                        acceder al histórico de tus operaciones y el controlar
                        tus créditos, configurar tu cuenta y adquirir más cuando
                        los necesites.

                        <br />Tanto para las firmas que creas como para aquellas
                        en las que eres firmante
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      flat
                      round
                      color="orange darken-4"
                      dark
                      bold
                      outline
                      @click="goOcr()"
                      >Ver Más</v-btn
                    >
                    <!--  <v-btn flat color="orange" to="/blank-page" >Legal</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-card>
          <v-flex xs12 md12 lg12>
            <v-card flat tile class="justify-center">
              <v-card-title primary-title xs12 sm3>
                <div class="text-xs-center">
                  <h3 class="headline text-center mb-0">
                    ¿Quieres probarlo?
                  </h3>
                </div>
              </v-card-title>
              <v-card-content>
                <div class="text-xs-center">
                  <v-btn
                    round
                    color="orange darken-4"
                    dark
                    bold
                    outline
                    @click="goContact()"
                    class="mr-4 elevation-5"
                    >Registra tus datos y nos pondremos en contacto
                    contigo</v-btn
                  >
                </div>
              </v-card-content>
            </v-card>
          </v-flex>

          <v-flex xs12 md12 lg12>
            <v-card flat tile class="justify-center">
              <v-card-title primary-title xs12 sm3>
                <div class="text-xs-center">
                  <h3 class="headline text-center mb-0">
                    O si quieres comenzar a trabajar con Securyty
                  </h3>
                </div>
              </v-card-title>
              <v-card-content>
                <div class="text-xs-center">
                  <v-btn
                    round
                    color="orange darken-4"
                    dark
                    bold
                    outline
                    @click="goRegister()"
                    class="mr-4 elevation-5"
                    >Regístrate como usuario para probar nuestros
                    servicios</v-btn
                  >
                </div>
              </v-card-content>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>

    <v-layout>
      <v-flex xs12 md8 lg8>
        <v-parallax
          md8
          src="/static/facial-recognition-data-points.jpg"
          class="mt-5"
        >
          <v-layout align-center column justify-center>
            <div class="display-3 white--text bold mb-4">
              VideoIdentificación
            </div>
            <div class="subheading white--text bold">
              Comienza a usar SECURYTY hoy mismo para identificar y enrolar a
              tus clientes <br />
              de forma efectiva y segura.
            </div>
          </v-layout>
        </v-parallax>
      </v-flex>
      <v-flex xs12 md4 lg4 class="mt-5">
        <div>
          Verifica la identidad de tus clientes o empleados de forma remota y
          desatendida, simplificando los trámites para los clientes y cumpliendo
          normativas existentes.

          <br />Comprueba coincidencia de caras con fotos en documentos y
          validez de los mismos
        </div>
        <div class="text-xs-center">
          <v-btn
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click="goRegister()"
            class="mr-4 elevation-5"
            >Regístrate como usuario para probar nuestros servicios</v-btn
          >
        </div>
      </v-flex>
    </v-layout>
    <v-layout>

      <v-flex xs12 md4 lg4 class="mt-5">
        <div>
          Verifica la identidad de tus clientes o empleados de forma remota y
          desatendida, simplificando los trámites para los clientes y cumpliendo
          normativas existentes.

          <br />Comprueba coincidencia de caras con fotos en documentos y
          validez de los mismos
        </div>
        <div class="text-xs-center">
          <v-btn
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click="goRegister()"
            class="mr-4 elevation-5"
            >Regístrate como usuario para probar nuestros servicios</v-btn
          >
        </div>
      </v-flex>      

      <v-flex xs12 md8 lg8>
        <v-parallax
          md8
          src="/static/facial-recognition-data-points.jpg"
          class="mt-5"
        >
          <v-layout align-center column justify-center>
            <div class="display-3 white--text bold mb-4">
              VideoIdentificación
            </div>
            <div class="subheading white--text bold">
              Comienza a usar SECURYTY hoy mismo para identificar y enrolar a
              tus clientes <br />
              de forma efectiva y segura.
            </div>
          </v-layout>
        </v-parallax>
      </v-flex>

      
    </v-layout>
  </v-container>
</template>
<script>
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      page: {
        title: "Securyty",
        headline: "Securyty ",
        description: `n`,
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false,
        },
        {
          text: "Views",
          disabled: false,
        },
        {
          text: "Blank",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    goContact() {
      this.$router.push({ name: "ContactPage" });
    },
    goRegister() {
      this.$router.push({ name: "RegisterPage" });
    },
    goSignature() {
      this.$router.push({ name: "SignaturePage" });
    },
    goIdentification() {
      this.$router.push({ name: "IdentificationPage" });
    },
    goNotification() {
      this.$router.push({ name: "NotificationPage" });
    },
    goLegal() {
      this.$router.push({ name: "legalInformationEs" });
    },
    goOcr() {
      this.$router.push({ name: "OcrPage" });
    },
  },
};
</script>
